import React, {Component} from "react";
import {FormInstance, Layout} from "antd";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import { Editor } from '@tinymce/tinymce-react'

const { Content } = Layout;
// const { TextArea } = Input;

interface IProps {
}

export default class Info extends Component<IProps> {
    formRef = React.createRef<FormInstance>();

    state = {
        content: ""
    }

    componentDidMount() {
    }

    render() {
        const crumb = [
            {name: '智能研报'},
            {name: '研报录入'},
        ];
        return (
            <Layout>
                <NavHeader/>
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <Editor
                                //value={"templateStr"}
                                id={"tincyEditor"}
                                tinymceScriptSrc={'/components/tinymce/js/tinymce/tinymce.min.js'}
                                apiKey="3b3mqocwkyibmni3e0hibs4rkr6rlkwjlss0gf0eeaqglvfv"
                                init={{
                                    language: 'zh_CN',
                                    width: 900,
                                    min_height: 600,
                                    plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize formatpainter',
                                    toolbar: 'bdmap indent2em lineheight formatpainter axupimgs',
                                    fontsize_formats: '8px 9px 10px 11px 12px 14px 16px 18px 24px 36px 48px 56px 72px',
                                }}
                                onEditorChange={this.handleEditorChange}
                                onInit={this.onInit}
                            />
                            <br/>
                            <br/>
                            {this.state.content}
                        </Content>
                    </Layout>
                </Content>
            </Layout>
        )
    }

    onInit = () => {
    }
    handleEditorChange = (content: string, editor: any) => {
        this.setState({content: content});
    }
}